import { createFileRoute } from '@tanstack/react-router';

import { HackathonDetailView } from '@/features/Hackathons/HackathonDetailView';

export const Route = createFileRoute('/admin/batches/$batchId/hackathons/$hackathonId')({
  component: AdminHackathonDetailTab,
});

export function AdminHackathonDetailTab() {
  const { batchId, hackathonId } = Route.useParams();
  return (
    <div className="p-6">
      <HackathonDetailView batchId={batchId} hackathonId={hackathonId} />
    </div>
  );
}
